import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { defineStore, storeToRefs } from 'pinia';
import axios from 'axios';
import { SNACKBAR_MESSAGE as CORE_SNACKBAR } from '~/core/constants/snackbar';
import { Category } from '~/core/enums';
import { FavouritesApi } from '~/core/api/favouritesApi';
import useMainSnackbarStore from '~/stores/useMainSnackbarStore';
import useLocaleStore from '~/stores/useLocaleStore';
import showError from '~/bridge/showError';
import { SNACKBAR_MESSAGE } from '~/features/DoctorsAndClinics/constants/snackbar';
import { FavouriteFoldersApi } from '~/features/DoctorsAndClinics/api/folders.api';
export default defineStore('favouritesStore', function () {
  var _useNuxtApp = useNuxtApp(),
    $captureException = _useNuxtApp.$captureException;
  var favouriteDoctors = ref([]);
  var favouriteClinics = ref([]);
  var favouriteFolders = ref([]);
  var favouritesFoldersCount = ref(0);
  var $snackbar = useMainSnackbarStore();
  var _storeToRefs = storeToRefs(useLocaleStore()),
    pdUrl = _storeToRefs.pdUrl;
  var isLoading = ref(false);
  var isFoldersLoading = ref(false);
  var isFolderDataLoading = ref(false);
  var favouritesFolderData = ref(null);
  var currentFolderId = ref(null);
  var doctorOrClinicItemsForHomeSection = computed(function () {
    return [].concat(_toConsumableArray(favouriteDoctors.value), _toConsumableArray(favouriteClinics.value)).sort(function (itemA, itemB) {
      return itemB.dtUpdated.localeCompare(itemA.dtUpdated);
    });
  });
  var showAppMenuButton = computed(function () {
    return favouriteDoctors.value.length > 0 || favouriteClinics.value.length > 0;
  });
  var favouritesFolderDoctorsCount = computed(function () {
    var _favouritesFolderData;
    return ((_favouritesFolderData = favouritesFolderData.value) === null || _favouritesFolderData === void 0 ? void 0 : _favouritesFolderData.doctorsInfo.length) || 0;
  });
  function fetchFavourites() {
    return _fetchFavourites.apply(this, arguments);
  }
  function _fetchFavourites() {
    _fetchFavourites = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$Promise$all, _yield$Promise$all2, favouriteDoctorsData, favouriteClinicsData;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            isLoading.value = true;
            _context.next = 4;
            return Promise.all([FavouritesApi.get(Category.Doctors), FavouritesApi.get(Category.Lpu)]);
          case 4:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            favouriteDoctorsData = _yield$Promise$all2[0];
            favouriteClinicsData = _yield$Promise$all2[1];
            favouriteDoctors.value = favouriteDoctorsData.data;
            favouriteClinics.value = favouriteClinicsData.data;
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            $captureException(_context.t0, {
              component: 'useDoctorsAndClinicsStore',
              method: 'fetchFavourites',
              message: 'Не удалось получить список избранных докторов и клиник'
            });
          case 15:
            _context.prev = 15;
            isLoading.value = false;
            return _context.finish(15);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 12, 15, 18]]);
    }));
    return _fetchFavourites.apply(this, arguments);
  }
  function removeFavourite(_x) {
    return _removeFavourite.apply(this, arguments);
  }
  function _removeFavourite() {
    _removeFavourite = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(item) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return FavouritesApi.delete(item.type, item.id);
          case 3:
            if (item.type === Category.Doctors) {
              favouriteDoctors.value = favouriteDoctors.value.filter(function (doctor) {
                return doctor.id !== item.id;
              });
            } else {
              favouriteClinics.value = favouriteClinics.value.filter(function (clinic) {
                return clinic.id !== item.id;
              });
            }
            $snackbar.open(_objectSpread(_objectSpread({}, CORE_SNACKBAR.FAVOURITES_DELETED), {}, {
              cancelHandler: function cancelHandler() {
                revertFavourite(item);
              }
            }));
            _context2.next = 10;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            $snackbar.open(CORE_SNACKBAR.TRY_AGAIN_ERROR);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return _removeFavourite.apply(this, arguments);
  }
  function revertFavourite(_x2) {
    return _revertFavourite.apply(this, arguments);
  }
  function _revertFavourite() {
    _revertFavourite = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(item) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return FavouritesApi.add(item.type, item.id, item.familyProfileUuid);
          case 3:
            if (item.type === Category.Doctors) {
              favouriteDoctors.value = [item].concat(_toConsumableArray(favouriteDoctors.value));
            } else {
              favouriteClinics.value = [item].concat(_toConsumableArray(favouriteClinics.value));
            }
            _context3.next = 9;
            break;
          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3["catch"](0);
            $snackbar.open(CORE_SNACKBAR.ERROR_WITH_RELOAD);
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 6]]);
    }));
    return _revertFavourite.apply(this, arguments);
  }
  function redirectToPd(item) {
    window.open("".concat(pdUrl.value).concat(item.urlPath), '_blank');
  }
  function getAvatarImage(avatar, type, pdUrl) {
    if (avatar) {
      return "".concat(pdUrl, "/").concat(avatar);
    }
    if (type === Category.Lpu) {
      return '/graphics/no-avatar-clinic.svg';
    }
    if (type === Category.Doctors) {
      return '/graphics/no-avatar-doctor.svg';
    }
  }
  function fetchFavouritesFolders() {
    return _fetchFavouritesFolders.apply(this, arguments);
  }
  function _fetchFavouritesFolders() {
    _fetchFavouritesFolders = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _yield$FavouriteFolde, data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!(favouriteFolders.value.length > 0)) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return");
          case 2:
            _context4.prev = 2;
            isFoldersLoading.value = true;
            _context4.next = 6;
            return FavouriteFoldersApi.get();
          case 6:
            _yield$FavouriteFolde = _context4.sent;
            data = _yield$FavouriteFolde.data;
            favouritesFoldersCount.value = data.foldersCount;
            favouriteFolders.value = data.favoriteFolders;
            _context4.next = 15;
            break;
          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](2);
            $captureException(_context4.t0, {
              component: 'useDoctorsAndClinicsStore',
              method: 'fetchFavouritesFolders',
              message: 'Не удалось загрузить подборки пользователя'
            });
          case 15:
            _context4.prev = 15;
            isFoldersLoading.value = false;
            return _context4.finish(15);
          case 18:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 12, 15, 18]]);
    }));
    return _fetchFavouritesFolders.apply(this, arguments);
  }
  function fetchFavouritesFolderData(_x3) {
    return _fetchFavouritesFolderData.apply(this, arguments);
  }
  function _fetchFavouritesFolderData() {
    _fetchFavouritesFolderData = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
      var _yield$FavouriteFolde2, data, _e$response, isNotFoundError;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            favouritesFolderData.value = null;
            _context5.prev = 1;
            isFolderDataLoading.value = true;
            _context5.next = 5;
            return FavouriteFoldersApi.getFolderData(id);
          case 5:
            _yield$FavouriteFolde2 = _context5.sent;
            data = _yield$FavouriteFolde2.data;
            favouritesFolderData.value = data;
            _context5.next = 15;
            break;
          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](1);
            isNotFoundError = axios.isAxiosError(_context5.t0) && ((_e$response = _context5.t0.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 404;
            if (!isNotFoundError) {
              $captureException(_context5.t0, {
                component: 'useDoctorsAndClinicsStore',
                method: 'fetchFavouritesFolderData',
                message: 'Не удалось загрузить врачей из подборки'
              });
            }
            showError(_context5.t0);
          case 15:
            _context5.prev = 15;
            isFolderDataLoading.value = false;
            return _context5.finish(15);
          case 18:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 10, 15, 18]]);
    }));
    return _fetchFavouritesFolderData.apply(this, arguments);
  }
  function redirectToPdFromFolder(item) {
    var redirectUrl = new URL(item.urlPath, pdUrl.value).toString();
    window.open(redirectUrl);
  }
  function deleteDoctorFromFolder(_x4) {
    return _deleteDoctorFromFolder.apply(this, arguments);
  }
  function _deleteDoctorFromFolder() {
    _deleteDoctorFromFolder = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(item) {
      var favouriteFolderFromCommonList;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!(!favouritesFolderData.value || !currentFolderId.value)) {
              _context6.next = 2;
              break;
            }
            return _context6.abrupt("return");
          case 2:
            _context6.prev = 2;
            _context6.next = 5;
            return FavouriteFoldersApi.deleteDoctorFromFolder(currentFolderId.value, item.idProdoctorov);
          case 5:
            favouritesFolderData.value.doctorsInfo = favouritesFolderData.value.doctorsInfo.filter(function (doctor) {
              return doctor.idProdoctorov !== item.idProdoctorov;
            });
            favouriteFolderFromCommonList = favouriteFolders.value.find(function (folder) {
              return folder.id === currentFolderId.value;
            });
            if (favouriteFolderFromCommonList) {
              favouriteFolderFromCommonList.doctorsInfo = favouritesFolderData.value.doctorsInfo;
              favouriteFolderFromCommonList.doctorsCount--;
            }
            $snackbar.open(_objectSpread(_objectSpread({}, SNACKBAR_MESSAGE.DOCTOR_REMOVED_FOLDER), {}, {
              cancelHandler: function cancelHandler() {
                revertDoctorDeletionFromFolder(item);
              }
            }));
            _context6.next = 14;
            break;
          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6["catch"](2);
            $snackbar.open(CORE_SNACKBAR.TRY_AGAIN_ERROR);
          case 14:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[2, 11]]);
    }));
    return _deleteDoctorFromFolder.apply(this, arguments);
  }
  function revertDoctorDeletionFromFolder(_x5) {
    return _revertDoctorDeletionFromFolder.apply(this, arguments);
  }
  function _revertDoctorDeletionFromFolder() {
    _revertDoctorDeletionFromFolder = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(item) {
      var favouriteFolderFromCommonList;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (!(!favouritesFolderData.value || !currentFolderId.value)) {
              _context7.next = 2;
              break;
            }
            return _context7.abrupt("return");
          case 2:
            _context7.prev = 2;
            _context7.next = 5;
            return FavouriteFoldersApi.addDoctorToFolder(currentFolderId.value, item.idProdoctorov);
          case 5:
            favouritesFolderData.value.doctorsInfo = [item].concat(_toConsumableArray(favouritesFolderData.value.doctorsInfo));
            favouriteFolderFromCommonList = favouriteFolders.value.find(function (folder) {
              return folder.id === currentFolderId.value;
            });
            if (favouriteFolderFromCommonList) {
              favouriteFolderFromCommonList.doctorsInfo = favouritesFolderData.value.doctorsInfo;
              favouriteFolderFromCommonList.doctorsCount++;
            }
            _context7.next = 13;
            break;
          case 10:
            _context7.prev = 10;
            _context7.t0 = _context7["catch"](2);
            $snackbar.open(CORE_SNACKBAR.ERROR_WITH_RELOAD);
          case 13:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[2, 10]]);
    }));
    return _revertDoctorDeletionFromFolder.apply(this, arguments);
  }
  return {
    isLoading: isLoading,
    favouriteDoctors: favouriteDoctors,
    favouriteClinics: favouriteClinics,
    doctorOrClinicItemsForHomeSection: doctorOrClinicItemsForHomeSection,
    showAppMenuButton: showAppMenuButton,
    favouritesFoldersCount: favouritesFoldersCount,
    favouriteFolders: favouriteFolders,
    isFoldersLoading: isFoldersLoading,
    isFolderDataLoading: isFolderDataLoading,
    favouritesFolderData: favouritesFolderData,
    favouritesFolderDoctorsCount: favouritesFolderDoctorsCount,
    currentFolderId: currentFolderId,
    fetchFavourites: fetchFavourites,
    removeFavourite: removeFavourite,
    redirectToPd: redirectToPd,
    getAvatarImage: getAvatarImage,
    fetchFavouritesFolders: fetchFavouritesFolders,
    fetchFavouritesFolderData: fetchFavouritesFolderData,
    redirectToPdFromFolder: redirectToPdFromFolder,
    deleteDoctorFromFolder: deleteDoctorFromFolder
  };
});